import { render, staticRenderFns } from "./EditorViewDialog.vue?vue&type=template&id=12580b4c&scoped=true&"
import script from "./EditorViewDialog.vue?vue&type=script&lang=js&"
export * from "./EditorViewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12580b4c",
  null
  
)

export default component.exports